import React, { Component } from 'react';
import classNames from 'classnames';

import { HAS_WINDOW } from '@eb/feature-detection';

const withStickyBehavior = (
    StickyComponent,
    { onScroll, topAdjust = 0 } = {},
) =>
    class WithStickyBehaviorWrapper extends Component {
        constructor(props) {
            super(props);

            this.state = {
                scrolledPastComponent: false,
            };

            this.scrollListener = null;
        }

        componentDidMount() {
            const { scrolledPastComponent } = this.state;

            if (this._containerRef && this._contentRef) {
                const contentHeight =
                    topAdjust > 0
                        ? document.querySelector('.eds-tabs__navigation')
                              .clientHeight
                        : this._contentRef.clientHeight;

                this.setState({
                    contentHeight,
                });

                let containerPaddingTop = '0px';

                if (scrolledPastComponent) {
                    containerPaddingTop = `${this._contentRef.clientHeight}px`;
                }

                this._containerRef.style.paddingTop = containerPaddingTop;
                this.scrollListener = window.addEventListener(
                    'scroll',
                    this._checkScrollPosition,
                );
            }
        }

        componentWillUnmount() {
            this.scrollListener = null;
        }

        _checkScrollPosition = () => {
            if (HAS_WINDOW && this._containerRef && this._contentRef) {
                const { contentHeight } = this.state;
                const tabsContent = document.querySelector(
                    '.eds-tabs__content',
                );

                if (tabsContent) {
                    const topPosition =
                        tabsContent.offsetTop +
                        document.querySelector('.eds-tabs__navigation')
                            .clientHeight;
                    const scrolledPastComponent = window.scrollY >= topPosition;

                    let containerPaddingTop = '0px';

                    if (scrolledPastComponent) {
                        containerPaddingTop = `${contentHeight}px`;
                    }

                    this._containerRef.style.paddingTop = containerPaddingTop;

                    this.setState({
                        scrolledPastComponent,
                    });

                    if (onScroll) {
                        onScroll({
                            navBarHeight: this._containerRef.clientHeight,
                        });
                    }
                }
            }
        };

        render() {
            const { scrolledPastComponent } = this.state;

            const containerRef = (el) => {
                this._containerRef = el;
            };

            const contentRef = (el) => {
                this._contentRef = el;
            };

            const contentClassNames = classNames({
                'with-sticky-behavior': scrolledPastComponent,
                'without-sticky-behavior ': !scrolledPastComponent,
            });

            return (
                <div ref={containerRef} className={contentClassNames}>
                    <div ref={contentRef}>
                        <StickyComponent
                            {...this.props}
                            isSticky={scrolledPastComponent}
                        >
                            {this.props.children}
                        </StickyComponent>
                    </div>
                </div>
            );
        }
    };

export default withStickyBehavior;
